import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  mediaFadeRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const bannerRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const media = selector('[data-motion-media]')[0]
  const pretitle = selector('[data-motion-pretitle]')[0]
  const title = selector('[data-motion-title]')[0]
  const text = selector('[data-motion-text]')[0]
  const cta = selector('[data-motion-cta]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let mediaAnimation: SharedAnimation
  if (media) {
    mediaAnimation = mediaFadeRevealAnimation(media)
    timeline.add(mediaAnimation.timeline, 0)
  }

  let pretitleAnimation: SharedAnimation
  if (pretitle) {
    pretitleAnimation = linesRevealAnimation(pretitle, reverse)
    timeline.add(pretitleAnimation.timeline, 0.2)
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0.3)
  }

  let textAnimation: SharedAnimation
  if (text) {
    textAnimation = linesRevealAnimation(text, reverse)
    timeline.add(textAnimation.timeline, 0.4)
  }

  let ctaAnimation: SharedAnimation
  if (cta) {
    ctaAnimation = fadeRevealAnimation(cta)
    timeline.add(ctaAnimation.timeline, 0.6)
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    mediaAnimation?.revert()
    pretitleAnimation?.revert()
    titleAnimation?.revert()
    textAnimation?.revert()
    ctaAnimation?.revert()
  }
}
